import { IMAGE_BASE_URL } from "../../../utils/env";
import LoadingImg from "../../ui/LoadingImg";
import noImgCoffee from "../../../assets/images/noImg.jpg";
import { CartItem } from "../../../types/response";
import { selectCurrentUserId } from "../../../features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { selectProductDetails, setAddQty, setSelectedAddonsArray } from "../../../features/guest/guestSlice";
import { clearTypeOfShowModalType, setTypeModal } from "../../../features/modal/modalSlice";
import { EditIcon, Remove } from "../../../assets/icons/Icons";

interface CartItemProps {
    cart: CartItem;
    isProductAvailable: boolean | undefined;
    firstWord: string;
    isLoadingRemoveItemCart: boolean;
    handleUpdateQty: (currentQty: number, productID: number, sizeId: number, typeOfUpdate: 'increase' | 'decrease', cartItemID: number) => void;
    handleRemoveItemCart: (productId: number, guestId: number, cartItemID: number) => void;
    isDisabledRemoveItem: boolean;
    isDisabledQty: boolean;
    loadingItemId: number | null;
    isStoreOpen: boolean;
    storeOpen: boolean;
    isActive: boolean;
    isAvailable: boolean;
}

export default function MyCartItem({ cart, isProductAvailable, firstWord, isLoadingRemoveItemCart, handleUpdateQty, handleRemoveItemCart, isDisabledRemoveItem, isDisabledQty, loadingItemId, isStoreOpen, storeOpen, isActive, isAvailable, }: CartItemProps) {

    const dispatch = useDispatch()
    const disabled = !isProductAvailable || !isActive || !isAvailable
    const addons = cart.addons ?? [];
    const guestId = useSelector(selectCurrentUserId)
    const [isLoadingImg, setIsLoadingImg] = useState<boolean>(true);
    const [showAllAddons, setShowAllAddons] = useState(false);

    const overlay = !isActive
    ? {
        //   title: "Inactive Product",
        title: "Unavailable",
        message: "This product has been removed and can no longer be ordered.",
    } : !isAvailable
    ? {
        //   title: "Currently Unavailable",
        title: "Unavailable",
        message: "This product is temporarily unavailable.",
    } : !isProductAvailable
    ? {
        title: "Expired",
        message: "This product is not available at the current time.",
    } : null;

    return (
        <div className={`relative flex-col rounded border p-2 ${disabled ? 'border-red-300 bg-red-50' : ''}`}>
            <div className={`flex items-start gap-1 ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}>
                {/* Image */}
                <div className="relative h-20 w-20 flex-shrink-0">
                    {isLoadingImg && (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <LoadingImg />
                        </div>
                    )}
                    <img
                        src={cart.image ? `${IMAGE_BASE_URL}/${cart.image}` : noImgCoffee}
                        alt={cart.productName}
                        className={`${
                            isLoadingImg ? "opacity-0" : "opacity-100"
                        } h-full w-full rounded-lg object-cover`}
                        onLoad={() => setIsLoadingImg(false)}
                        onError={(e) => {
                            setIsLoadingImg(false);
                            e.currentTarget.src = noImgCoffee;
                        }}
                    />
                </div>
                {/* Order Details */}
                <div className="flex min-w-0 flex-1 flex-col gap-1">
                    <div className="flex w-full items-start gap-2">
                        <div className="min-w-0 flex-1">
                            <p className={`${showAllAddons ? "whitespace-normal break-words" : "truncate"} text-xs font-medium`}>
                                {firstWord} | {cart.productName}
                            </p>
                            <div className={`text-xs ${showAllAddons ? "" : "line-clamp-2"}`}>
                                {addons.map((add, index) => (
                                    <p
                                        key={add.addonID ?? `${add.addonName}-${index}`}
                                        className={`flex items-center gap-2 text-xs
                                            ${add.isActive
                                                ? "text-gray-700"
                                                : "text-red-500 line-through"}
                                        `}
                                    >
                                        <span>•</span>
                                        <span>{add.addonName}</span>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="flex space-x-1">
                        <div className="inline-flex w-fit rounded border border-orange-500 bg-orange-100 px-1.5 py-0 text-xs font-medium">
                            {cart.size}
                        </div>
                    </div>
                    {/* <div className="text-xs">
                        Qty: 4
                    </div> */}
                </div>
                {/* Actions */}
                <div className="flex self-stretch flex-col items-center justify-between">
                    {isLoadingRemoveItemCart ? (
                        <LoadingImg />
                    ) : (
                        <>
                            {/* <div className="grid grid-cols-2 gap-1"> */}
                            <div className="flex flex-col justify-between h-full">
                                
                                <button
                                    onClick={() => {
                                        if (guestId) {
                                            handleRemoveItemCart(cart.productID, guestId, cart.cartItemID);
                                        }
                                    }}
                                    disabled={isDisabledRemoveItem}
                                    className={`flex items-center space-x-1 text-[12px] font-semibold text-cbColor ${!isStoreOpen ? "cursor-not-allowed" : ""}`}
                                >
                                    <Remove color={`#aa6833`} size={`15`}/>
                                    <span>Remove</span>
                                </button>
                                <div className="text-[13px] font-medium text-right">
                                    {`Qty: ${cart.qty}`}
                                </div>
                                <button
                                    onClick={() => {
                                        dispatch(setTypeModal("selectedItem"));
                                        dispatch(setSelectedAddonsArray(cart.addons))
                                        dispatch(setAddQty(cart.qty))
                                        dispatch(selectProductDetails({packageID: cart.packageID, productID: cart.productID, sizeID: cart.sizeId, type: 'update', cartItemID: cart.cartItemID}))
                                        dispatch(clearTypeOfShowModalType())
                                    }}
                                    // disabled={isDisabledRemoveItem}
                                    className={`flex space-x-1 items-center justify-center text-[12px] py-0.5 px-1 font-semibold border border-cbColor rounded text-cbColor ${!isStoreOpen ? "cursor-not-allowed" : ""}`}
                                >
                                    <EditIcon size="15"/>
                                    <span>Edit</span>
                                </button>
                            </div>
                            {/* <div className="flex items-center rounded-md bg-gray-100">
                                <button
                                    className="flex h-8 w-8 items-center justify-center disabled:cursor-not-allowed"
                                    disabled={isDisabledQty || disabled}
                                    onClick={() => handleUpdateQty( cart.qty, cart.productID, cart.sizeId, "decrease", cart.cartItemID)}
                                >
                                    -
                                </button>
                                <span className="w-8 text-center font-semibold">
                                    {loadingItemId === cart.productID ? (
                                        <Loading isDefault={false} message="" spinH="w-3 h-3" />
                                    ) : (
                                        cart.qty
                                    )}
                                </span>
                                <button
                                    className="flex h-8 w-8 items-center justify-center disabled:cursor-not-allowed"
                                    disabled={isDisabledQty || disabled}
                                    onClick={() => handleUpdateQty( cart.qty, cart.productID, cart.sizeId, "increase", cart.cartItemID)}
                                >
                                    +
                                </button>
                            </div> */}
                        </>
                    )}
                </div>
            </div>
            {overlay && (
                <span className="inline-flex w-fit rounded border border-red-500 bg-red-100 text-red-500 px-2 py-0.5 text-xs font-medium">
                    {overlay.title}
                </span>
            )}
        </div>
    )
}
